module.exports = __webpack_public_path__ + "assets/img/one-tab6-on.74718b3c.png";